import { Injectable } from "@angular/core";
import {
  MetaModel,
  WidgetModel,
} from "common/models/utility-models/base-model";
import { FormWidgetService } from "../form-widget.service";
import { FeedbackPreviewDataService } from "common/services/data-services/admin/feedback-preview/feedback-preview-data.service";
import {
  SmMetaInputModel,
  SmMetaModel,
  SmMetaMultipleChoiceModel,
  SmMetaSelectModel,
  SmMetaTextAreaModel,
} from "common/models/utility-models/meta-model";
import { FeedbackPreviewModel } from "common/models/page-models/feedback-preview/feedback-preview-data-model";
import { FeedbackPreviewMetaModel } from "common/models/page-models/feedback-preview/feedback-preview-meta-model";

@Injectable({
  providedIn: "root",
})
export class FeedbackPreviewWidgetService extends FormWidgetService<FeedbackPreviewModel> {
  constructor(protected ds: FeedbackPreviewDataService) {
    super(ds);
  }
  getMetaModel(): MetaModel {
    const meta = new FeedbackPreviewMetaModel();
    return meta.getMetaModel();
  }
  override prepareMetaModel(
    dataModel: any,
    metaModel: FeedbackPreviewMetaModel,
    routeData: WidgetModel
  ): Promise<FeedbackPreviewMetaModel> {
    return new Promise<FeedbackPreviewMetaModel>((resolve, reject) => {
      // console.log(dataModel)
      metaModel["formTitle"] = dataModel.title;
      metaModel["categories"] = dataModel.categorydata;
      // dataModel[0].category.forEach((cat) => {
      //     metaModel.properties[cat.category] = [];
      //     metaModel.properties[cat.category]['title'] = cat.category;
      // })
      // metaModel.properties['noCategory'] = [];
      const cat:any[]= metaModel["categories"].map((item) => item.category);

      dataModel.questions.forEach((question) => {
        // console.log(question.question_type,'question.question_type');
        
        switch (question.question_type) {
          case 0:
            // console.log(' case 0');
            
            metaModel.properties[question.id] = new SmMetaInputModel(
              String(question.id),
              String(question.id),
              "input",
              true,
              "col-12 col-md-6",
              1,
              1,
              question.question_text,
              "text",
              "",
              false,
              true,
              true,
              false,
              100,
              1
            );
            metaModel.properties[question.id]["selectedCategory"] = cat.includes(question.selected_category_text)
              ? question.selected_category_text
              : "";
            break;
          case 1:
            let options: any[] = [];
            question.options.forEach((option) => {
              let opt = {
                value: option.option_text,
                id: option.id,
                field_name: option.id,
                label: option.option_text,
              };
              options = [...options, opt];
            });
            // console.log(' case 1',options);

            metaModel.properties[question.id] = new SmMetaMultipleChoiceModel(
              String(question.id),
              String(question.id),
              "singleChoice",
              true,
              "col-12 col-md-6",
              1,
              2,
              question.question_text,
              "number",
              "",
              false,
              true,
              true,
              false,
              0,
              0,
              false,
              options,
              "",
              "id",
              false,
              false,
              false,
              false,
              false,
              false
            );
            metaModel.properties[question.id]["selectedCategory"] = cat.includes(question.selected_category_text)
              ? question.selected_category_text
              : "";
            break;
          case 2:
            let yesNoOptions: any[] = [
              {
                value: 1,
                id: `${question.id}_yes`,
                field_name: "Yes",
                label: "Yes",
              },
              {
                value: 0,
                id: `${question.id}_no`,
                field_name: "No",
                label: "No",
              },
            ];
            // console.log(' case 2',yesNoOptions);

            metaModel.properties[question.id] = new SmMetaMultipleChoiceModel(
              String(question.id), // Use a unique identifier for yes/no options
              String(question.id), // Use the same identifier for consistency
              "singleChoice",
              true,
              "col-12 col-md-6",
              1,
              2,
              question.question_text,
              "number",
              "",
              false,
              true,
              true,
              false,
              0,
              0,
              false,
              yesNoOptions,
              "",
              "id",
              false,
              false,
              false,
              false,
              false,
              false
            );
            metaModel.properties[question.id]["selectedCategory"] = cat.includes(question.selected_category_text)
              ? question.selected_category_text
              : "";
            break;
          case 3:
            // console.log(' case 3');

            metaModel.properties[question.id] = new SmMetaInputModel(
              String(question.id),
              String(question.id),
              "ratings",
              true,
              "col-12 col-md-6",
              1,
              1,
              question.question_text,
              "text",
              "",
              false,
              true,
              true,
              false,
              100,
              1
            );
            metaModel.properties[question.id]["selectedCategory"] = cat.includes(question.selected_category_text)
              ? question.selected_category_text
              : "";
            break;
          case 4:
            let dropdownOptions: any[] = [];
            // console.log(' case 4');

            metaModel.properties[question.id] = new SmMetaSelectModel(
               String(question.id),
              String(question.id),
              "select",
              true,
              "col-12 col-md-6 col-lg-6",
              1,
              1,
              question.question_text,
              "select",
              "",
              false,
              true,
              true,
              false,
              0,
              0,
              false,
              question.options,
              "option_text",
              "id"
            );
            metaModel.properties[question.id]["selectedCategory"] = cat.includes(question.selected_category_text)
              ? question.selected_category_text
              : "";
            break;
         
         
            case 5:
            metaModel.properties[question.id] = new SmMetaTextAreaModel(
              String(question.id),
              String(question.id),
              "SimpleTextarea",
              true,
              "col-12 col-md-6",
              1,
              1,
              question.question_text,
              "text",
              "",
              false,
              true,
              true,
              false,
              500,
              1,
              false,
              false
            );
            metaModel.properties[question.id]["selectedCategory"] = cat.includes(question.selected_category_text)
              ? question.selected_category_text
              : "";
            break;
          case 6:
            let mcqoptions: any[] = [];
            question.options.forEach((option) => {
              let opt = {
                value: option.option_text,
                id: option.id,
                field_name: option.id,
                label: option.option_text,
              };
              mcqoptions = [...mcqoptions, opt];
            });
            metaModel.properties[question.id] = new SmMetaMultipleChoiceModel(
              String(question.id),
              String(question.id),
              "multipleChoice",
              true,
              "col-12 col-md-6",
              1,
              2,
              question.question_text,
              "number",
              "",
              false,
              true,
              true,
              false,
              0,
              0,
              false,
              mcqoptions,
              "",
              "id",
              true,
              false,
              false,
              false,
              false,
              false
            );
            metaModel.properties[question.id]["selectedCategory"] = cat.includes(question.selected_category_text)
              ? question.selected_category_text
              : "";
            break;
        }
      });

      // Object.keys(metaModel.properties).forEach((props) => {
      //     metaModel.properties['selectedCategory'].push(props);
      // })
      resolve(metaModel);
    });
  }
}
